import { useContext } from "react";

import PropTypes from "prop-types";

import { AccordionContext } from "common/contexts";

import Accordion from "./accordion-item";

const AccordionBBC = ({ list, multipleOpen, ...props }) => {
  const { active } = useContext(AccordionContext);

  return (
    <Accordion
      multipleOpen={multipleOpen}
      defaultActiveKey={`${active || ""}`}
      className={`bbc-accordion ${props.className}`}
    >
      {list?.length > 0 &&
        list.map((item, index) => (
          <Accordion.Item
            eventKey={`${item.name.toLowerCase().split(" ").join("-")}`}
            className={"border-b border-[#797979]"}
            key={index}
          >
            {({ open }) => (
              <>
                <Accordion.Button
                  className={`relative w-full cursor-pointer py-6 text-left text-lg font-medium before:absolute
                 before:right-3 before:top-1/2 before:h-6  before:w-[1px] before:-translate-y-1/2 before:bg-bbc-gray before:content-[''] after:absolute after:right-3
                 after:top-1/2 after:h-6 after:w-[1px] after:-translate-y-1/2 after:rotate-90 after:bg-bbc-gray after:content-[''] lg:px-[50px] lg:before:right-10 lg:after:right-10 ${
                   open && "before:rotate-90"
                 } before:transition-all
                 ${props.buttonClass || ""}`}
                >
                  <h3
                    className={"pr-6 text-bbc-gray"}
                    dangerouslySetInnerHTML={{ __html: item.name }}
                  ></h3>
                </Accordion.Button>
                <Accordion.Panel
                  className={`bbc-accordion-panel transition-all lg:px-[50px] ${props.panelClass}`}
                >
                  <div dangerouslySetInnerHTML={{ __html: item.content }} />
                </Accordion.Panel>
              </>
            )}
          </Accordion.Item>
        ))}
    </Accordion>
  );
};

export default AccordionBBC;
AccordionBBC.propTypes = {
  multipleOpen: PropTypes.bool,
  list: PropTypes.array,
  defaultActiveKey: PropTypes.number,
};

AccordionBBC.defaultProps = {
  multipleOpen: false,
  list: [],
  defaultActiveKey: null,
};

/** ========== */
